import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Styled Elements
// import { TableWrapper } from './ReportsTravelRule.elements'

// Utils
import { getCustomerStatus } from 'common/utils/customerValidation'
import { App, Header, Sidebar, Content, PageWrapper, ReportsSubHeader } from 'views/layouts'
import { ReportsTravelRuleTable, DemoReportsTable } from 'views/containers'
import { Container } from 'views/components'

function ReportsTravelRule() {
  const [csi] = useState(getCustomerStatus())

  return (
    <App>
      <Sidebar />
      <Header subHeader={<ReportsSubHeader />} pageTitle="Reports" />
      {/* <NoAccess /> */}
      <Content>
        <PageWrapper>
          <Container>
            {csi === 1 && <ReportsTravelRuleTable />}

            {csi !== 1 && <DemoReportsTable />}
          </Container>
        </PageWrapper>
      </Content>
    </App>
  )
}

// Default Props
ReportsTravelRule.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
}

// Proptypes Validation
ReportsTravelRule.propTypes = {
  actions: PropTypes.shape({
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    showAlert: PropTypes.func,
  }),
  filters: PropTypes.shape({
    whitelistingFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
}

export default ReportsTravelRule
